import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {ChartOptions} from "../../../../components/dashboard/apex-hospital-chart/apex-hospital-chart.component";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {ChartConfiguration} from "chart.js";

@Component({
  selector: 'app-graph-list-horizontal',
  templateUrl: './graph-list-horizontal.component.html',
  styleUrls: ['./graph-list-horizontal.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class GraphListHorizontalComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;
  // @ViewChild(matSteppe) stepper!: MatHorizontalStepper;
  public areaChartOptions!: Partial<ChartOptions>;
  colors: any[] = [{backgroundColor: ["#0b5ba8", "#6114be", "#15dcdc"]}];
  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false
  };
  public doughnutChartLabels: string[] = ['Difficulty in Coping up', 'Not able to Cope up','Able to Cope up'];
  doughnutChartDatasets?:ChartConfiguration<'doughnut'>['data']['datasets']
  constructor() { }
  @Input() mAssessments!: AssessmentModel[]
  @Input() type: 'FollowUp'|'Assessment'='Assessment'

  ngOnInit(): void {
    console.log('into horizontal graph',this.mAssessments);
  }
   calculateGraphData(data: AssessmentModel) {
    let chartdata:any
    let chartConfig:any
    let totalYes = 0
    let totalNo = 0
    let totalSometimes = 0
if(this.type=='Assessment') {
  let currentYes = data.assessment.filter((questionModel) => questionModel.ans == 'Yes').length
  let currentNo = data.assessment.filter((questionModel) => questionModel.ans == 'No').length
  let currentsometimes = data.assessment.filter((questionModel) => questionModel.ans == 'Sometimes').length

  totalYes = totalYes += currentYes
  totalNo = totalNo += currentNo
  totalSometimes = totalSometimes += currentsometimes
}



    chartConfig =[totalSometimes,totalYes,totalNo,]
    chartdata= [
      {data: chartConfig, label: '' ,backgroundColor: ["#fbc02d",  "#af1111","#00695c"]},

    ];
    return chartdata
  }
  calculateFGraphData(data: any) {
    let chartdata:any
    let chartConfig:any
    let totalYes = 0
    let totalNo = 0
    let totalSometimes = 0
    if(this.type=='FollowUp') {
      let currentYes = data.questions.filter((questionModel: { ans: string; }) => questionModel.ans == 'Yes').length
      let currentNo = data.questions.filter((questionModel: { ans: string; }) => questionModel.ans == 'No').length
      let currentsometimes = data.questions.filter((questionModel: { ans: string; }) => questionModel.ans == 'Sometimes').length

      totalYes = totalYes += currentYes
      totalNo = totalNo += currentNo
      totalSometimes = totalSometimes += currentsometimes
    }



    chartConfig =[totalSometimes,totalYes,totalNo,]
    chartdata= [
      {data: chartConfig, label: '' ,backgroundColor: ["#fbc02d",  "#af1111","#00695c"]},

    ];
    return chartdata
  }

}
